<script setup lang="ts">
import { useRegisterSW } from "virtual:pwa-register/vue";
import { watch } from "vue";
import Notifier from "@/plugins/notifications/Notifier";

const { needRefresh, updateServiceWorker } = useRegisterSW();

watch(needRefresh, async () => {
	if (needRefresh.value === true) {
		const toast = await Notifier.useAppUpdateToast();
		await toast.present();
		const { role } = await toast.onDidDismiss();
		if (role === "update") {
			await Notifier.showSuccess({
				message: "Erfolgreich aktualisiert. <br/>Applikation wird neu geladen",
				position: "top",
				color: "success",
				duration: 5000,
			});
			await updateServiceWorker();
		}
	}
});
</script>

<template>
	<div></div>
</template>

<style></style>
